<!-- 商品排行榜管理 -->
<style scoped>
.img {
  height: 30px;
}
.ellipsis-1 {
  max-width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
}
.w150 {
  width: 150px;
}
</style>
<template>
  <div class="pageCentent">
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <!-- 搜索条件 -->
      <a-form-model
        size="small"
        layout="inline"
        :model="ajaxparams"
        @keyup.native.enter="$refs.myTable.search()"
      >
        <a-form-model-item label="类型">
          <a-select
            style="width: 150px"
            allowClear
            v-model="ajaxparams.type"
            placeholder="请选择类型"
          >
            <a-select-option :value="1">新品</a-select-option>
            <a-select-option :value="2">经典</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="品牌">
          <a-select
            style="width: 150px"
            allowClear
            v-model="ajaxparams.brand_id"
            placeholder="请选择品牌"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in brandData"
              :key="index"
              >{{ item.brand_name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>

        <a-form-model-item>
          <a-button icon="search" @click="$refs.myTable.search()" type="primary"
            >搜索</a-button
          >
        </a-form-model-item>
      </a-form-model>

      <!-- 按钮 -->
      <!-- <a-space>
        <a-button type="primary" @click="dialogClick('add')">添加</a-button>
      </a-space> -->

      <!-- 表格 -->
      <MyTable
        :isSelection="false"
        class="mt10"
        :apiUrl="apiUrl"
        :params="ajaxparams"
        ref="myTable"
        :columns="columns"
      >
        <a-space slot="button" slot-scope="item, row">
          <a-popconfirm
            title="确定删除?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="delConfirm(row)"
          >
            <a-button size="small" type="danger">删除</a-button>
          </a-popconfirm>
        </a-space>

        <a-space slot="cover_img" slot-scope="item, row">
          <img
            v-if="row.goods && row.goods.cover_img"
            style="width: 30px; height: 30px"
            :src="IMGHOST + '/' + row.goods.cover_img"
          />
          <span v-else>-</span>
        </a-space>

        <a-space slot="goods_price" slot-scope="item, row">
          <span v-if="row.goods">{{ row.goods.goods_price / 100 }}</span>
          <span v-else>-</span>
        </a-space>

        <a-space slot="goods_name" slot-scope="item, row">
          <span v-if="row.goods">{{ row.goods.goods_name }}</span>
          <span v-else>-</span>
        </a-space>

        <a-space slot="brand_name" slot-scope="item, row">
          <span>{{ getBrandName(row.brand_id) }}</span>
        </a-space>

        <a-space slot="type" slot-scope="item, row">
          <span>{{ getTypeName(row.type) }}</span>
        </a-space>

        <a-space slot="rank" slot-scope="item, row, index">
          <editable-cell
            :ref="'edittableCell' + row.id"
            :text="row.rank"
            @change="onCellChange($event, row, index)"
          />
        </a-space>
      </MyTable>
    </div>

    <!-- 添加排行榜商品弹窗 -->
    <a-modal
      :maskClosable="false"
      v-model="dialogVisible"
      title="添加排行榜商品"
      :confirm-loading="submitLoading"
      @ok="onSubmit"
      @cancel="handleCancel"
      width="600px"
    >
      <a-form-model :rules="rules" ref="formModel" size="small" :model="form">
        <a-form-model-item label="类型" prop="type">
          <a-select v-model="form.type" placeholder="请选择类型">
            <a-select-option :value="1">新品</a-select-option>
            <a-select-option :value="2">经典</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="品牌" prop="brand_id">
          <a-select
            v-model="form.brand_id"
            placeholder="请选择品牌"
            @change="onBrandChange"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in brandData"
              :key="index"
              >{{ item.brand_name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="商品" prop="goods_id">
          <a-select
            v-model="form.goods_id"
            placeholder="请选择商品"
            :disabled="!form.brand_id"
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in goodsList"
              :key="index"
              >{{ item.goods_name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="排序" prop="rank">
          <a-input-number
            v-model="form.rank"
            placeholder="请输入排序"
            :min="1"
            style="width: 100%"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import EditableCell from "@/components/editableCell.vue";
import {
  GoodsRank_index,
  GoodsRank_add,
  GoodsRank_del,
  Coupon_edit,
} from "@/api/goods";
import { brand_index } from "@/api/goods";
import { goods_index } from "@/api/goods";

export default {
  components: { MyTable, EditableCell },
  data() {
    return {
      IMGHOST: window.IMGHOST,
      apiUrl: GoodsRank_index,
      ajaxparams: {
        page: 1,
        limit: 20,
      },
      dialogType: "",
      dialogVisible: false,
      brandData: [], // 品牌数据
      goodsList: [], // 商品列表
      columns: [
        {
          title: "封面",
          ellipsis: true,
          dataIndex: "cover_img",
          key: "cover_img",
          width: 80,
          scopedSlots: { customRender: "cover_img" },
        },
        {
          title: "商品名称",
          ellipsis: true,
          dataIndex: "goods_name",
          key: "goods_name",
          width: 200,
          scopedSlots: { customRender: "goods_name" },
        },
        {
          title: "类型",
          ellipsis: true,
          dataIndex: "type",
          key: "type",
          width: 100,
          scopedSlots: { customRender: "type" },
        },
        {
          title: "品牌名称",
          ellipsis: true,
          dataIndex: "brand_name",
          key: "brand_name",
          width: 120,
          scopedSlots: { customRender: "brand_name" },
        },
        {
          title: "商品价格",
          ellipsis: true,
          dataIndex: "goods_price",
          key: "goods_price",
          width: 100,
          scopedSlots: { customRender: "goods_price" },
        },
        {
          title: "排序",
          ellipsis: true,
          dataIndex: "rank",
          key: "rank",
          width: 80,
          scopedSlots: { customRender: "rank" },
        },
        {
          title: "创建时间",
          ellipsis: true,
          dataIndex: "create_at",
          key: "create_at",
          width: 160,
        },
        {
          title: "操作",
          key: "operation",
          fixed: "right",
          width: 100,
          scopedSlots: { customRender: "button" },
        },
      ],
      form: {},
      rules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        brand_id: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
        goods_id: [
          { required: true, message: "请选择商品", trigger: "change" },
        ],
        rank: [{ required: true, message: "请输入排序", trigger: "change" }],
      },
      submitLoading: false,
    };
  },
  created() {
    this.getBrandData();
  },
  mounted() {},
  destroyed() {},
  methods: {
    // 获取品牌数据
    async getBrandData() {
      try {
        const res = await brand_index({ page: 1, limit: 1000 });
        // 品牌数据从res.list获取，只显示品牌ID为4,5,6的品牌
        const allBrands = res.list || [];
        this.brandData = allBrands.filter((item) =>
          [4, 5, 6].includes(item.id)
        );
      } catch (error) {
        console.error("获取品牌数据失败:", error);
      }
    },

    // 品牌变更时获取对应商品
    async onBrandChange(brandId) {
      this.form.goods_id = undefined; // 清空商品选择
      if (brandId) {
        try {
          const res = await goods_index({
            page: 1,
            limit: 1000,
            brand_id: brandId,
            is_shelves: 1, // 只获取上架商品
          });
          this.goodsList = res.result.list || [];
        } catch (error) {
          console.error("获取商品数据失败:", error);
          this.goodsList = [];
        }
      } else {
        this.goodsList = [];
      }
    },

    // 商品搜索过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    // 取消弹窗
    handleCancel() {
      this.submitLoading = false;
      this.dialogVisible = false;
      this.form = {};
      this.goodsList = [];
    },

    // 提交表单
    async onSubmit() {
      this.$refs.formModel.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          try {
            await GoodsRank_add(this.form);
            this.$message.success("操作成功");
            setTimeout(() => {
              this.$refs.myTable.getList();
              this.submitLoading = false;
              this.dialogVisible = false;
              this.form = {};
              this.goodsList = [];
            }, 1500);
          } catch (error) {
            this.submitLoading = false;
            console.error("添加失败:", error);
          }
        } else {
          return false;
        }
      });
    },

    // 删除确认
    async delConfirm(val) {
      try {
        await GoodsRank_del({ id: val.id });
        this.$message.success("操作成功");
        setTimeout(() => {
          this.$refs.myTable.getList();
        }, 1500);
      } catch (error) {
        console.error("删除失败:", error);
      }
    },

    // 打开弹窗
    dialogClick(type, row) {
      this.dialogType = type;
      this.form = {
        type: undefined,
        brand_id: undefined,
        goods_id: undefined,
        rank: 1,
      };
      this.goodsList = [];
      this.dialogVisible = true;
    },

    // 获取品牌名称
    getBrandName(brandId) {
      const brand = this.brandData.find((item) => item.id === brandId);
      return brand ? brand.brand_name : "-";
    },

    // 获取类型名称
    getTypeName(type) {
      const typeName = {
        1: "新品",
        2: "经典",
      };
      return typeName[type] || "-";
    },

    // 修改排序
    async onCellChange(e, row, index) {
      if (!e || e == 0) {
        this.$refs["edittableCell" + row.id].resetEdit(row.rank);
        this.$message.warning("排序值必须大于0");
        return;
      }
      try {
        await Coupon_edit({ id: row.id, rank: e });
        this.$message.success("操作成功");
      } catch (error) {
        this.$refs["edittableCell" + row.id].resetEdit(row.rank);
        console.error("修改排序失败:", error);
      }
    },
  },
};
</script>
